import React from 'react';
import { Modal } from 'antd';
import i18n from '../../lib/i18n';

export default function EmailVerifyError() {
  Modal.error({
    title: i18n.t('modals.emailVerify.title'),
    content: i18n.t('modals.emailVerify.content'),
    okText: i18n.t('modals.emailVerify.ok'),
  });
}
